export const BRAND = {
  name: 'Convometry',
  endorsement: 'by Estateflow',
  domain: 'convometry.com',
  descriptor: 'Analítica de conversaciones de venta por WhatsApp.',
  tagline: 'Mide y mejora las conversaciones de venta por WhatsApp.',
} as const;
